import {EventEmitter, Injectable} from '@angular/core';
import * as uuid from 'uuid';
import {environment} from "../../environments/environment";

export enum RoomName{
   SYNC_PRODUCTS = "room_sync_product",
   EXPORT_DATA = "room_export_data",
   BADGE_DA_APPROVARE = "room_badge_da_approvare",
   IMPORT_PRODOTTI = "import_prodotti",
   TEST = "room_test"
}

export enum ChannelEventEnum {
   ND = "nd",
   PROGRESS = "progress",
   PROGRESS_FILE = "progress_file",
   END = "end",
   ERR = "err",
   START = "start",
   IMPORT_FILE = "import_file"
}


export class MessageData{
   sender?: string
   data?: any
   message?: any
   broadcast?: boolean
   current?: number;
   total?: number;
   detail?: string;
   counter?: number;
   end?: Boolean;
   event?: ChannelEventEnum
   op?: string;
   obj?: string;
   created?: string;
}

export class CKWebSocket {

   public onMessage:EventEmitter<MessageData> = new EventEmitter<MessageData>()
   public hasError = true;

   private ws:WebSocket
   private room: string
   private sender: string

   constructor(ws:WebSocket, room:string, sender:string, event:ChannelEventEnum|null=null) {
      this.room = room
      this.ws = ws
      this.sender = sender

      ws.onopen = (event)=>{
         console.log(`%c[WS] Connessione alla stanza ${room} avvenuta con successo`,
            "background: green; color: white")
         this.hasError = false
      }

      ws.onerror = (event) =>{
         console.error("[WS] on error")
         this.hasError = true
      }

      ws.onmessage = (message:MessageEvent)=>{

         let data = JSON.parse(message.data)
         let payload: MessageData = data.payload

         if(event && payload.event != event){
            console.warn("messaggio scartato")
            return;
         }
         // console.warn("new message", payload)

         if(payload.sender == this.sender) {
            // console.warn("sono io")
            return;
         }
         this.onMessage.emit(payload)
      }

   }

   sendMessage(msgData: MessageData) {

      if(!this.ws){
         console.warn("socket non inizializzata")
         return
      }

      if(this.hasError){
         console.warn("socket non aperta")
         return;
      }

      msgData.sender = this.sender
      if(msgData.broadcast == null) msgData.broadcast = true

      try {
         this.ws.send(JSON.stringify(msgData))
      }catch (e) {
         console.error(e)
         console.warn("Impossibile chiudere il ws")
      }

   }

   public isOpened(){
      if(!this.ws){
         console.log(`isOpened: null`)
         return false
      }
      console.log(`isOpened: ${this.ws.readyState == WebSocket.OPEN}`)
      return this.ws.readyState == WebSocket.OPEN
   }

   public close(){
      this.ws.close()
   }

}

@Injectable({
   providedIn: 'root'
})
export class WebsocketService {

   private sender = uuid.v4();
   private hasError = false;
   private connessioni:any = {}

   constructor() {}

   connect(room: RoomName|string, event:ChannelEventEnum|null=null): CKWebSocket|null {

      let roomName = room.toString().replace("room_", "")
      let urlServer = environment.urlServer

      urlServer = urlServer.replace(/\/app$/, "")
      urlServer = urlServer.replace("https", "wss")
      urlServer = urlServer.replace("http", "ws")
      urlServer += "/ws/" + roomName

      console.log("Connessione at " + urlServer + " ...")

      try{
         let ws = new WebSocket(urlServer);
         let rmsws = new CKWebSocket(ws, roomName, this.sender, event)
         this.connessioni[roomName] = rmsws
         return rmsws
      }catch (e) {
         console.error("connect")
         console.error(e)
         return null;
      }

   }

   disconnect(room: string) {
      let ws:WebSocket = this.connessioni[room]
      ws.close()
   }

   getRoom(room:string): CKWebSocket{
      return this.connessioni[room]
   }

}



// sendMessage(ws:WebSocket, msgData: MessageData) {
//
//    if(!ws){
//       console.warn("socket non inizializzata")
//       return
//    }
//
//    if(this.hasError){
//       console.warn("socket non aperta")
//       return;
//    }
//
//    msgData.sender = this.sender
//    if(msgData.broadcast == null) msgData.broadcast = true
//
//    try {
//       ws.send(JSON.stringify(msgData))
//    }catch (e) {
//       console.error(e)
//       console.warn("Impossibile chiudere il ws")
//    }
//
// }
